import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import DashboardPage from "@/pages/DashboardPage";
import AlertsPage from "@/pages/AlertsPage";
import CompetitorsPage from "@/pages/CompetitorsPage";
import SocialPage from "@/pages/SocialPage";
import SocialDetailPage from "@/pages/SocialDetailPage";
import AIVisibilityPage from "@/pages/AIVisibilityPage";
import RecommendationsPage from "@/pages/RecommendationsPage";
import SettingsPage from "@/pages/SettingsPage";
import DairyPage from "@/pages/DairyPage";
import Chatbot from "@/components/Chatbot";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/alerts" element={<AlertsPage />} />
            <Route path="/competitors" element={<CompetitorsPage />} />
            <Route path="/social" element={<SocialPage />} />
            <Route path="/social/detail" element={<SocialDetailPage />} />
            <Route path="/ai-visibility" element={<AIVisibilityPage />} />
            <Route path="/recommendations" element={<RecommendationsPage />} />
            <Route path="/dairy" element={<DairyPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Routes>
        <Chatbot />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
